import { Box, Button, TextField } from '@mui/material';
import TextFieldComponent from 'components/TextFieldComponent';
import React, { ChangeEvent } from 'react';

interface FormsProposalProps {
  formData: { image1?: File | null; image2?: File | null };
  onChange: (data: { image1?: File | null; image2?: File | null }) => void;
  goToNextPage: () => void;
}

const FormsProposalThird: React.FC<FormsProposalProps> = ({
  formData,
  onChange,
  goToNextPage,
}) => {
  function handleChange(event: ChangeEvent<HTMLInputElement>): void {
    const { name, value, files } = event.target;
    if (name === 'image1' || name === 'image2') {
      onChange({
        ...formData,
        [name]: files && files[0] ? files[0] : null,
      });
    } else {
      onChange({
        ...formData,
        [name]: value,
      });
    }
  }

  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 3,
        backgroundColor: 'var(--app-surface-2)',
        width: '100%',
        height: '80%',
        boxShadow: '0 4px 24px rgba(24, 19, 19, 0.25)',
        padding: 3,
        gap: 2,
        '@media (max-width: 600px)': {
          padding: 2,
          width: '100%',
        },
      }}
    >
      <Box
        component="h2"
        sx={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#fff', mb: 2 }}
      >
        Confirme o modelo de aquisição
      </Box>
      <Button
        onClick={goToNextPage}
        sx={{
          backgroundColor: '#1976d2',
          color: 'white',
          '&:hover': {
            backgroundColor: '#115293',
          },
        }}
        variant="contained"
      >
        Salvar
      </Button>
    </Box>
  );
};

export default FormsProposalThird;
